import defineComponent from 'flight';
import memberInfo from 'static/script/app/data/member-info';

function ContactSellerButton () {

    this.defaultAttrs({
        bus: {}
    });

    this._onClick = function (evt) {
        evt.preventDefault();

        if (!memberInfo.isLoggedIn) {
            let destination = location.protocol + '//' + location.host + location.pathname + location.search + '#' + 'modal=contact';
            this.trigger(document, 'ui:login:show', { destination: encodeURIComponent(destination) });
            return;
        }

        let payload = {
            modalTitle: 'Ställ en fråga till säljaren',
            messageSubject: 'Meddelande från köpare: ' + this.$node.data('itemtitle'),
            itemEnddate: this.$node.data('itemenddate'),
            itemId: this.$node.data('itemid'),
            itemImageUrl: this.$node.data('itemimageurl'),
            itemTitle: this.$node.data('itemtitle'),
            receiverMemberAlias: this.$node.data('receivermemberalias'),
            receiverMemberId: this.$node.data('receivermemberid'),
            senderMemberAlias: memberInfo.memberAlias,
            businessWarning: true,
            reloadAfterClose: false
        };

        this.attr.bus.trigger('ui:contact-modal:show-modal', payload);
    };

    this.after('initialize', function () {
        this.attr.bus.on('ui:contact-service:on-sent-ga', function (payload) {
            this.trigger(document, 'analytics:track-event', payload);
        }.bind(this));

        this.on('click', this._onClick);
    });
}

module.exports = defineComponent.component(ContactSellerButton);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-seller-button.js